import { OrgTypesEditorView } from '@today/ui-domain'
import { useTranslation } from 'react-i18next'
import { useOrgTypes } from '@/hooks/organization/useOrgTypes'
import { ORGANIZATION_NAMESPACE } from '@/i18n'

/** The Types tab (REQ-009): write controls only with `organization_type.write` and manifest EDIT. */
export function TypesTab({ canWrite }: { canWrite: boolean }) {
	const { t } = useTranslation(ORGANIZATION_NAMESPACE)
	const types = useOrgTypes({ t })
	return (
		<OrgTypesEditorView
			t={t}
			state={types.state}
			rows={types.rows}
			editor={types.editor}
			parentTypeOptions={types.parentTypeOptions}
			deleting={types.deleting}
			isBusy={types.isBusy}
			onRetry={types.retry}
			onEditorChange={types.change}
			onEditorSubmit={types.submit}
			onEditorClose={types.close}
			onConfirmDelete={types.confirmDelete}
			onCancelDelete={types.cancelDelete}
			onNew={canWrite ? types.openNew : undefined}
			onEdit={canWrite ? types.openEdit : undefined}
			onDelete={canWrite ? types.askDelete : undefined}
		/>
	)
}
